import { render, staticRenderFns } from "./FormGeneral.vue?vue&type=template&id=1ff9b881&scoped=true&"
import script from "./FormGeneral.vue?vue&type=script&lang=js&"
export * from "./FormGeneral.vue?vue&type=script&lang=js&"
import style0 from "./FormGeneral.vue?vue&type=style&index=0&id=1ff9b881&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff9b881",
  null
  
)

export default component.exports